module.exports = __webpack_public_path__ + "static/media/ic-alert.2b0e49fc.svg";